import { Collapsible } from "@similarweb/ui-components";
import type { ICollapsibleProps } from "@similarweb/ui-components";
import { is } from "app/pages/sales-intelligence/utils/type-guards";
import styled, { css } from "styled-components";

export const StyledCollapsible = styled(Collapsible)<ICollapsibleProps & { maxHeight?: number | string }>`
    ${(p) => {
        if (is.undefined(p.maxHeight)) {return;}

        const maxHeight = is.string(p.maxHeight) ? p.maxHeight : `${p.maxHeight}px`;

        return css`
            max-height: ${p.isActive ? maxHeight : "0"};
        `;
    }}
    &.expanded {
        overflow: visible;
    }
`;
